import {
  SET_PRODUCTS,
  SET_COLOURS,
  SET_SIZES,
  UPDATE_CAT,
  INIT_QUOTE,
  ADD_PRODUCT,
  SET_LOGO,
  SET_VALID_DATE,
  SET_QUOTE_LABEL,
  SET_CONTACTUSER,
  SET_CONTACTADDRESS,
  SET_CONTACTINFO,
  SET_COMPANY,
  SET_DELIVERY_REQUIRED,
  SET_PICKUP_INSTORE,
  SET_COLLECTION_ID,
  SET_QUOTE_ID,
  SET_REVISE,
  SET_TOTAL_PRICE,
  SET_TOTAL_PRICE_EX,
  SET_TOTAL_ACCEPTED_PRICE,
  SET_GST,
  SET_CUSTOMERS,
  UPDATE_QUOTE,
  SET_MARGIN_VALUE,
  SET_MARGIN_PERCENT,
  SET_CONTACT_UPDATED,
  SET_COMPANY_UPDATED,
  SET_LOADING,
  SET_CLIENT_LABEL,
  SET_DEFAULT_BRAND,
  SET_COMPANY_LOADING,
  SET_QUOTE_LOADING,
  SET_TEMPLATE_LOADING,
  SET_PRODUCTION_LOADING,
  SET_SETTING_LOADING,
  SET_OPEN_CONFIRM_EDIT_MODAL,
  SET_QUOTE_COMPANY,
  SET_PRODUCT_UPLOADED,
  SET_CLIENT_ORDER_NUMBER
} from '../actions/quote';

export default function quote(state = {
    products:[],
    colournames:[],
    sizenames:[],
    categories:{},
    logo:null,
    productInfo:{},
    selectedContactUser:null,
    selectedContactAddress:null,
    selectedContactInfo:null,
    selectedCompany:null,
    delivery_required:false,
    validDate:null,
    logoImage:null,
    companies:null,
    loadingFlag:false,
    defaultBrand: 'Embroidery',
    totalPrice: 0,
    totalPriceEx: 0,
    companyLoaded: false,
    quoteLoading: false,
    templateLoading: false,
    productionLoading: false,
    settingLoading: false,
    openConfirmEditModal: false,
    company:{},
    productUploaded: false
}, {type, payload}) {
  switch (type) {
      case SET_OPEN_CONFIRM_EDIT_MODAL:
        return {
          ...state,
          openConfirmEditModal: payload
        }
      case SET_COMPANY_LOADING:
        return {
          ...state,
          companyLoaded: payload
        }
      case SET_CLIENT_ORDER_NUMBER:
        return {
          ...state,
          wfm_order_no: payload
        }
      case SET_PRODUCT_UPLOADED:
        return {
          ...state,
          productUploaded: payload
        }
      case SET_QUOTE_COMPANY:
        return {
          ...state,
          company: payload
        }
      case SET_QUOTE_LOADING:
        return {
          ...state,
          quoteLoading: payload
        }
      case SET_TEMPLATE_LOADING:
        return {
          ...state,
          templateLoading: payload
        }
      case SET_PRODUCTION_LOADING:
        return {
          ...state,
          productionLoading: payload
        }
      case SET_SETTING_LOADING:
        return {
          ...state,
          settingLoading: payload
        }
      case SET_LOADING:
        return {
          ...state,
          loadingFlag: payload
        }
      case SET_DEFAULT_BRAND:
        return {
          ...state,
          defaultBrand: payload
        }
      case SET_PRODUCTS:
          var products = payload.products;
          return {
            ...state,productInfo:{
              ...state.productInfo, [payload.category]:{
                ...state.productInfo[payload.category], products: products
              }
            }
          }
      case SET_COLOURS:
          var colournames = payload.colournames;
          return {
            ...state,productInfo:{
              ...state.productInfo, [payload.category]:{
                ...state.productInfo[payload.category], colournames: colournames
              }
            }
          }
      case SET_SIZES:
          var sizenames = payload.sizenames;
          return {
            ...state,productInfo:{
              ...state.productInfo, [payload.category]:{
                ...state.productInfo[payload.category], sizenames: sizenames
              }
            }
          }
      case UPDATE_CAT:
        return {
          ...state,
          categories: {
            ...state.categories,
            ...payload
          }
        }
      case INIT_QUOTE:
        return {
          ...state,
          products:[],
          colournames:[],
          sizenames:[],
          categories:{},
          logo:null,
          // productInfo:{},
          selectedContactUser:null,
          selectedContactAddress:null,
          selectedContactInfo:null,
          selectedCompany:null,
          delivery_required:false,
          validDate:null,
          logoImage:null,
          companies:null,
          companyLoaded:false  ,
          id:null,
          quoteLabel: null,
          clientLabel: null,   
          created_at: null ,   
          wfm_order_no: null  
        }
      case UPDATE_QUOTE:
        return {
          ...state, ...payload
        }
      case SET_LOGO:
        return {
          ...state,
          logoImage: payload
        }
      case  SET_TOTAL_PRICE:
        return {
          ...state,
          totalPrice: payload
        }
      case SET_TOTAL_PRICE_EX:
        return {
          ...state,
          totalPriceEx: payload
        }
      case  SET_MARGIN_VALUE:
        return {
          ...state,
          marginValue: payload
        }
      case  SET_MARGIN_PERCENT:
        return {
          ...state,
          marginPercent: payload
        }
      case  SET_TOTAL_ACCEPTED_PRICE:
        return {
          ...state,
          totalAcceptedPrice: payload
        }
      case  SET_GST:
        return {
          ...state,
          gst: payload
        }
      case SET_REVISE:
        return {
          ...state,
          revision: payload
        }
      case SET_VALID_DATE:
        return {
          ...state,
          validDate: payload
        }
      case SET_QUOTE_LABEL:  
      return {
        ...state,
        quoteLabel: payload
      }
      case SET_CLIENT_LABEL:
        return {
          ...state,
          clientLabel: payload
        }
      case SET_CONTACTUSER:
        return {
          ...state,
          selectedContactUser: payload
        }        
      case SET_CONTACTADDRESS:
        return {
          ...state,
          selectedContactAddress: payload
        }
      case SET_CONTACTINFO:
        return {
          ...state,
          selectedContactInfo: payload
        }
      case SET_COMPANY:
        return {
          ...state,
          selectedCompany: payload
        }
      case SET_DELIVERY_REQUIRED:
        return {
          ...state,
          delivery_required: payload
        }
      case SET_PICKUP_INSTORE:
        return {
          ...state,
          pickup_instore: payload
        }
      case SET_COLLECTION_ID:
        return {
          ...state,
          collection_id: payload
        }
      case SET_QUOTE_ID:
        return {
          ...state,
          id: payload
        }
      case SET_CUSTOMERS:
        return {
          ...state,
          companies: payload
        }
      case SET_CONTACT_UPDATED:  
        return {
          ...state,
          contact_updated: payload
        }
      case SET_COMPANY_UPDATED:  
        return {
          ...state,
          company_updated: payload
        }
      default:
          return state;
  }
}